import { chancelVisitEndpoint, methods } from '../../utils/apiHelper'
import { apiCall } from '../../utils/restclient'
import {
  CLEAR_VISIT_DATA,
  CREATE_VISIT_REMARK,
  CREATE_VISIT_REMARK_ERROR,
  CREATE_VISIT_REMARK_SUCCESS,
  CREATE_VISIT_REMARK_SUCCESS_ACTION,
  GET_REMARKS,
  GET_REMARKS_ERROR,
  GET_REMARKS_SUCCESS,
  GET_VISIT_INFO,
  GET_VISIT_INFO_ERROR,
  GET_VISIT_INFO_SUCCESS,
  GET_VISITS,
  GET_VISITS_ERROR,
  GET_VISITS_SUCCESS,
  REMOVE_VISIT_ITEM_BY_ID,
  RESOLVE_VISIT,
  RESOLVE_VISIT_ERROR,
  RESOLVE_VISIT_SUCCESS,
  VISITS_SET_ERROR,
  CHANGE_VISIT_STATUS,
  CANCEL_VISIT,
  CANCEL_VISIT_SUCCESS,
  CANCEL_VISIT_ERROR,
  SET_IS_VISIT_STATUS_CHANGED_SUCCESS,
  VISITS_SET_DONT_REFRESH,
} from './VisitsConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setVisitError = (value) => ({
  type: VISITS_SET_ERROR,
  payload: value,
})
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setDontRefresh = (value) => ({
  type: VISITS_SET_DONT_REFRESH,
  payload: value,
})
export const getVisits = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  fromDate,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  toDate,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  searchValue,
  visitsMode = 'Past',
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  Offset,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  Count,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  visitTypesFilterRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  statusFilterRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  tagFilterRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  drugScreenStatusesFilterRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  identityVerificationStatusesFilterRow,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  activeFlags,
}) => {
  const include = visitsMode === 'Past' ? 'IsIncludePast' : 'IsIncludeUpcoming'

  const api = 'api/v1/visits'
  let query = `?fromDateTime=${encodeURIComponent(fromDate)}&toDateTime=${encodeURIComponent(
    toDate,
  )}&Offset=${Offset}&Count=${Count}`

  // Add filter rows to the query if they exist
  if (visitTypesFilterRow) {
    query += `&${visitTypesFilterRow}`
  }
  if (tagFilterRow) {
    query += `&${tagFilterRow}`
  }
  if (statusFilterRow) {
    query += `&${statusFilterRow}`
  }
  if (drugScreenStatusesFilterRow) {
    query += `&${drugScreenStatusesFilterRow}`
  }
  if (identityVerificationStatusesFilterRow) {
    query += `&${identityVerificationStatusesFilterRow}`
  }

  // Add search value to the query if it exists
  if (searchValue) {
    query += `&SearchValue=${encodeURIComponent(searchValue)}`
  }

  // Deduplicate and add active flags
  const uniqueFlags = [...new Set(activeFlags)]
  uniqueFlags.forEach((flag) => {
    query += `&${flag}=true`
  })

  // Add the include flag based on visitsMode
  query += `&${include}=true`

  // Filter the query string to ensure no duplicates
  const queryParams = new URLSearchParams(query)
  const uniqueQueryParams = new URLSearchParams()

  queryParams.forEach((value, key) => {
    if (!uniqueQueryParams.has(key)) {
      uniqueQueryParams.set(key, value)
    }
  })

  // Construct the final query string
  const filteredQuery = uniqueQueryParams.toString()
  const endpoint = `${api}?${filteredQuery}`

  // API call action
  const action = {
    type: GET_VISITS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_VISITS_SUCCESS,
      error: GET_VISITS_ERROR,
    })
  } catch (e) {
    console.error('API Call Error:', e)
  }
  return action
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getRemarks = (visitId) => {
  console.log('phew')
  const endpoint = `api/v1/visits/${visitId}/remarks`

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_REMARKS_SUCCESS,
      error: GET_REMARKS_ERROR,
      extraData: { visitId },
    })

    return {
      type: GET_REMARKS,
    }
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const createVisitRemark = (visitId, Message) => {
  const endpoint = `api/v1/visits/${visitId}/remarks`
  const action = {
    type: CREATE_VISIT_REMARK,
  }
  try {
    apiCall(
      endpoint,
      'POST',
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      JSON.stringify({ Message }),
      {
        success: { success: CREATE_VISIT_REMARK_SUCCESS, successAction: CREATE_VISIT_REMARK_SUCCESS_ACTION },
        error: CREATE_VISIT_REMARK_ERROR,
        extraData: { visitId },
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}

export const resetCreateVisitRemarkSuccess = () => ({
  type: CREATE_VISIT_REMARK_SUCCESS_ACTION,
})
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const removeVisitItemById = (id) => ({
  type: REMOVE_VISIT_ITEM_BY_ID,
  payload: id,
})

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const resolveVisit = ({ visitId, description }) => {
  const endpoint = `api/v1/visits/${visitId}/resolve`
  const action = {
    type: RESOLVE_VISIT,
  }

  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'PUT', null, JSON.stringify({ Message: description }), {
      success: RESOLVE_VISIT_SUCCESS,
      error: RESOLVE_VISIT_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function cancelVisitFromVisitsPage(visitId, reasonId, comment) {
  const endpoint = chancelVisitEndpoint(visitId)
  const action = {
    type: CANCEL_VISIT,
  }
  const body = reasonId ? JSON.stringify({ ReasonId: reasonId, Comment: comment ?? null }) : null
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.DELETE, null, body, {
      success: CANCEL_VISIT_SUCCESS,
      error: CANCEL_VISIT_ERROR,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

export const clearVisitData = () => ({
  type: CLEAR_VISIT_DATA,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getVisitInfo(visitId) {
  const endpoint = `api/v1/visits/${visitId}`
  const action = {
    type: GET_VISIT_INFO,
  }
  apiCall(
    endpoint,
    'GET',
    null,
    null,
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    {
      success: GET_VISIT_INFO_SUCCESS,
      error: GET_VISIT_INFO_ERROR,
    },
    null,
    null,
    0,
    false,
  )
  return action
}

export const changeVisitStatus = ({ newStatus = '', visitId = '' }) => ({
  type: CHANGE_VISIT_STATUS,
  payload: { newStatus, visitId },
})
export const getVisitInfoPromiseAction = () => ({
  type: GET_VISIT_INFO,
})

export const setIsVisitStatusChangedSuccess = (value = false) => ({
  type: SET_IS_VISIT_STATUS_CHANGED_SUCCESS,
  payload: value,
})
